var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
// tslint:disable:max-line-length
// This file is generated by generateStyles script.
// Please don't edit it manually.
import * as React from "react";
import "../../less/svg/ArrowWide.less";
export var ArrowWide = function (props) { return (React.createElement("svg", { viewBox: "0 0 112.63 41.13" },
    React.createElement("defs", null),
    React.createElement("g", __assign({ id: "Layer_2" }, props, { className: "ArrowWide " + props.className }),
        React.createElement("g", { id: "building_upgrade_dialog" },
            React.createElement("path", { className: "cls-1", d: "M94.62.89c-1.55-1.55-2.82-1-2.82 1.18v37c0 2.2 1.27 2.72 2.82 1.17l16.85-16.85a4 4 0 0 0 0-5.65z" }),
            React.createElement("rect", { className: "cls-1", y: 14.97, width: 100.01, height: 11.2, rx: 5.6 }))))); };



//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/ArrowWide.tsx
// module id = 2635
// module chunks = 3